/**
 @description: 吐司 Api（轻量 DOM 实现，避免 layer 全屏遮罩残留）
 */
let hideTimer = null
const TOAST_ID = 'vui-app-toast'

function removeToast() {
    const el = document.getElementById(TOAST_ID)
    if (el && el.parentNode) {
        el.parentNode.removeChild(el)
    }
    if (hideTimer) {
        clearTimeout(hideTimer)
        hideTimer = null
    }
    // 清理可能残留的 layer 吐司层
    try {
        const layer = require('../utils/layer/layer')
        layer.closeMsg && layer.closeMsg()
    } catch (e) {}
}

export default {
    show: (text, ...props) => {
        if (text === undefined || text === null || text.length === 0) {
            return
        }

        removeToast()

        const el = document.createElement('div')
        el.id = TOAST_ID
        el.textContent = text
        el.setAttribute(
            'style',
            [
                'position:fixed',
                'left:50%',
                'top:50%',
                'transform:translate(-50%,-50%)',
                'z-index:99999',
                'background:rgba(0,0,0,0.75)',
                'color:#fff',
                'padding:10px 20px',
                'border-radius:5px',
                'max-width:90%',
                'text-align:center',
                'font-size:15px',
                'line-height:1.4',
                'pointer-events:none',
                'box-sizing:border-box',
                'word-break:break-word'
            ].join(';')
        )
        document.body.appendChild(el)

        let duration = 2000
        props.forEach(prop => {
            if (typeof prop === 'string' && prop === 'LONG') {
                duration = 3500
            }
        })

        hideTimer = setTimeout(removeToast, duration)
    },
    hide: removeToast
}
